// extracted by mini-css-extract-plugin
export default {"countries":"PromoCountriesColumns-module__countries__LiLgI"};